import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";

function BulkTransactionFailed() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [sucessdata, setsucessdata] = useState([]);

  const error = useSelector(
    (state) => state.ownerAllVerification.uploadTransactionStatementError,
  );

  const godashboard = () => {
    navigate("/beneficiary_transaction_dashboard", { replace: true });
  };

  const UploadStatement = () => {
    navigate("/beneficiary_transaction_dashboard/create_bulk_transaction", {
      replace: true,
    });
  };

  const buttonRows = [
    [
      {
        btnText: "Create bulk transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--negative-bg)",
        icon: ICONS?.ADD_BUTTON_WHITE,
        handleFunction: UploadStatement,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--negative-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--negative-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS.DASHBOARD,
        handleFunction: godashboard,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  useEffect(() => {
    const data = sessionStorage.getItem("uploadTxnStatementData");
    setsucessdata(JSON.parse(data));
  }, []);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  return (
    <div>
      <StatusContainer
        status="error"
        buttonRows={buttonRows}
        title="Oops! File upload failed."
        subtitle="An error occurred with the uploading file, causing it to fail."
      >
        <TabsWeapperSection title="Error details">
          <>
            <InfoCard
              bgColor="var(--negative-card)"
              rows={[
                {
                  leftTitle: error?.errors?.base?.[0],
                  leftSubTitle: "Error message",
                },
              ]}
            />
          </>
        </TabsWeapperSection>
        <TabsWeapperSection title="Upload details">
          <>
            <InfoCard
              bgColor="var(--negative-card)"
              rows={[
                {
                  leftTitle: sucessdata?.category,
                  leftSubTitle: "Transaction category",
                  icon: sucessdata?.category?.logo_url
                    ? sucessdata?.category?.logo_url
                    : ICONS?.DEFAULT_CATEGORY,
                },
              ]}
            />
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </div>
  );
}

export default BulkTransactionFailed;
